$('body').css('scroll-snap-type', 'unset');

$('.nav-menu').addClass('active');

$(document).ready(function() {
    $('.preloader').css({'z-index': '-99999', 'opacity': '0'});

    if (window.location.hash) {
        document.querySelector("#customers-section-1").scrollIntoView({ behavior: "instant" });
        if (window.location.hash == '#recover') {
            $('#form_title').html('Reset Your Password');
            $('#customer_login').css('display', 'none');
            $('#forgot_password').css('display', 'block');
        }
        else if (window.location.hash == '#login') {
            $('#form_title').html('Customer\'s Login');
            $('#customer_login').css('display', 'block');
            $('#forgot_password').css('display', 'none');
        }
    }

});

$(window).on('resize', function(){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        isMobile = true;
    }
    else {
        isMobile = false;
    }
    
    hSize = $(window).height();
    wSize = $(window).width();
});

$('#recover').on('click', function() {
    $('#form_title').html('Reset Your Password');
    $('#customer_login').css('display', 'none');
    $('#forgot_password').css('display', 'block');
});

$('#cancel').on('click', function() {
    $('#form_title').html('Customer\'s Login');
    $('#customer_login').css('display', 'block');
    $('#forgot_password').css('display', 'none');
});

function deleteAddress(ms) {
    $('.delete-confirmation').hide();
    $('.'+ms).show();

    $('#AddAddress').hide();
    $('.form-edit').hide();
}
function dontDelete(ms) {
    $('.delete-confirmation').hide();
    $('.'+ms).hide();
}
function deleteIt(frm) {
    $('#'+frm).submit();
}

$('#new_country').on('change', function() {

    $('#new_province').html('');

    if ($(this).find(':selected').data('provinces').length > 0) {
        $('#newProvince_container').show();

        $.each($(this).find(':selected').data('provinces'), function(i, item) {
            $('#new_province').append('<option value="'+item[0]+'">'+item[0]+'</option');
        });
    }
    else {
        $('#newProvince_container').hide();
    }
});

function addAddress() {
    $('#AddAddress').show();
    $('.form-edit').hide();
}
function cancelAddAddress() {
    $('#AddAddress').hide();
    $('#newProvince_container').hide();
    $('#new_province').html('');
}

var update_id = 0;
function updateAddress(id) {
    $('#AddAddress').hide();
    $('.form-edit').hide();
    $('#EditAddress_'+id).show();

    $('#AddressCountry_'+id).val($('#AddressCountry_'+id).data('default'));


    if ($('#AddressCountry_'+id).find(':selected').data('provinces').length > 0) {
        $('#updateProvince_container_'+id).show();

        $.each($('#AddressCountry_'+id).find(':selected').data('provinces'), function(i, item) {
            $('#AddressProvince_'+id).append('<option value="'+item[0]+'">'+item[0]+'</option');
        });

        $('#AddressProvince_'+id).val($('#AddressProvince_'+id).data('default'));
    }
    else {
        $('#updateProvince_container_'+id).hide();
    }
}

$('.update-country').on('change', function() {

    $('.update-province').html('');

    if ($(this).find(':selected').data('provinces').length > 0) {
        $('.update-province-container').show();

        $.each($(this).find(':selected').data('provinces'), function(i, item) {
            $('.update-province').append('<option value="'+item[0]+'">'+item[0]+'</option');
        });
    }
    else {
        $('.update-province-container').hide();
    }
});

function cancelUpdateAddress() {
    $('.form-edit').hide();
    $('.update-province-container').hide();
    $('.update-province').html('');
}